import { useState, useEffect } from 'react';
import { networkUpdatesService, type ConnectionStatus } from '../../services/networkUpdatesService';

/**
 * Displays a banner when the SSE connection to the backend is lost or reconnecting.
 * Auto-hides when connection is restored.
 */
export const ConnectionStatusBanner = () => {
  const [status, setStatus] = useState<ConnectionStatus | null>(null);
  const [attempt, setAttempt] = useState(0);
  const [maxAttempts, setMaxAttempts] = useState(5);

  useEffect(() => {
    const unsubConnected = networkUpdatesService.subscribe('connected', () => {
      setStatus(null);
    });

    const unsubStatus = networkUpdatesService.subscribe('connection-status', (event) => {
      const s = event.data?.status as ConnectionStatus;
      setStatus(s);
      setAttempt(event.data?.attempt ?? 0);
      setMaxAttempts(event.data?.maxAttempts ?? 5);
    });

    return () => {
      unsubConnected();
      unsubStatus();
    };
  }, []);

  if (!status) return null;

  const isFailed = status === 'failed';

  return (
    <div className={`fixed top-0 left-0 right-0 z-9999 px-4 py-2 text-center text-sm font-medium ${
      isFailed
        ? 'bg-red-600 text-white'
        : 'bg-yellow-500 text-yellow-950'
    }`}>
      {isFailed ? (
        <>
          Verbindung zum Server verloren.{' '}
          <button
            onClick={() => window.location.reload()}
            className="underline font-bold hover:no-underline"
          >
            Seite neu laden
          </button>
        </>
      ) : (
        <>Verbindung wird wiederhergestellt ({attempt}/{maxAttempts})...</>
      )}
    </div>
  );
};
